import { useEffect, useState, useRef } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
    Input,
    Form,
    Select,
} from "@gpstrackit/react-controls";

//Notification
import { NotificationManager } from "Components/Notifications";

//Actions
import {
    changeUsernameUpdateRequest,
    clearRedux,
} from 'Redux/actions';

//Styles
import './index.scss';

const ChangeUsername = (props) => {
    const { getCompany, tableRef } = props;
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const formRef = useRef(null);

    //Local states
    const [newUsername, setNewUsername] = useState("");
    const [currentUsername, setCurrentUsername] = useState("");

    //Redux states
    const {
        loading,
        openModal,
        result,
        devices,
        device,
        simDetails,
        data
    } = useSelector(state => state.changeUsernameRedux)
    const { simProviderAccounts } = useSelector(state => state.generalRedux);

    const closeModal = () => {
        dispatch(clearRedux("CHANGE_USERNAME"));
        setNewUsername("");
        setCurrentUsername("");
    }

    const applyChanges = () => {
        let payload = {
            newUsername: newUsername,
            entityId: data.entityId,
            masterUser: data.masterUser
        }

        dispatch(changeUsernameUpdateRequest(payload));
    }

    useEffect(() => {
        if (result) {
            const { update } = result;
            if (update) {
                NotificationManager.success(
                    messages['change_username_saved_successfully'],
                    messages['change_username_title'],
                    3000
                );
                data?.tableRef && data?.tableRef?.current?.getData();
                getCompany && getCompany();
                closeModal();
            } else {
                NotificationManager.error(
                    result.error.error === "Username already exist" ?
                        messages['change_username_the_username_already_exist'] :
                        messages['change_username_the_was_an_error_in_the_save'],
                    messages['change_username_title'],
                    3000
                );
            }
            dispatch(clearRedux("CHANGE_USERNAME", { result: null }));
        }
    }, [result]);

    return (
        <Modal
            open={openModal}
            title={messages['change_username_title']}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={loading}
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <Form
                        ref={formRef}
                        onValidSubmit={() => applyChanges()}
                    >
                        <div className="edit-swap-disabled-input" style={{ marginBottom: 5 }}>
                            <Input
                                label={messages['change_username_current_username']}
                                placeholder={messages['change_username_current_username']}
                                value={data.currentUsername}
                                onChange={(value) => setCurrentUsername(value)}
                                disabled
                            />
                        </div>
                        <div className="edit-swap-disabled-input" style={{ marginBottom: 5 }}>
                            <Input
                                type="text"
                                label={messages['change_username_new_username']}
                                placeholder={messages['change_username_new_username']}
                                autoComplete="new-password"
                                value={newUsername}
                                onChange={(value) => setNewUsername(value)}
                                required
                                requiredMessage={messages['required_field']}
                                maxLength={20}
                                minLength={3}
                                minLengthMessage={`${messages['change_username_new_username_error_min']} 3`}
                                maxLengthMessage={`${messages['change_username_new_username_error_max']} 20`}
                                onBlur={() => {
                                    let currentUsername = newUsername || ''
                                    if (newUsername) {
                                        currentUsername = currentUsername.replace(/[^\w]/gi, '');
                                        currentUsername = currentUsername.toLowerCase();
                                        setNewUsername(currentUsername);
                                    }
                                }}
                            />
                        </div>
                    </Form>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={(e) => {
                        e.preventDefault();
                        closeModal();
                    }}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => formRef?.current?.submit()}
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default ChangeUsername; 